import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TruncatePipe } from './truncate/truncate.pipe';
import { IndexOfPipe } from './IndexOf/index-of.pipe';
import { RoundPipe } from './Round/round.pipe';



@NgModule({
    declarations: [
        TruncatePipe,
        IndexOfPipe,
        RoundPipe
    ],
    exports: [
        IndexOfPipe,
        RoundPipe
    ],
    imports: [
        CommonModule
    ]
})
export class PipeModule { }
